/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { IslandResponse } from '../models/island-response';
import { IslandsResponse } from '../models/islands-response';
import { Uuid } from '../models/uuid';

@Injectable({
  providedIn: 'root',
})
export class IslandsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getIslands
   */
  static readonly GetIslandsPath = '/api/islands';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getIslands()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIslands$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<IslandsResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IslandsService.GetIslandsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IslandsResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getIslands$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIslands(params?: {
  },
  context?: HttpContext

): Observable<IslandsResponse> {

    return this.getIslands$Response(params,context).pipe(
      map((r: StrictHttpResponse<IslandsResponse>) => r.body as IslandsResponse)
    );
  }

  /**
   * Path part for operation createIsland
   */
  static readonly CreateIslandPath = '/api/islands';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createIsland()` instead.
   *
   * This method doesn't expect any request body.
   */
  createIsland$Response(params: {
    name: string;
    catalog?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<IslandResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IslandsService.CreateIslandPath, 'post');
    if (params) {
      rb.query('name', params.name, {});
      rb.query('catalog', params.catalog, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IslandResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createIsland$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  createIsland(params: {
    name: string;
    catalog?: string;
  },
  context?: HttpContext

): Observable<IslandResponse> {

    return this.createIsland$Response(params,context).pipe(
      map((r: StrictHttpResponse<IslandResponse>) => r.body as IslandResponse)
    );
  }

  /**
   * Path part for operation getIsland
   */
  static readonly GetIslandPath = '/api/islands/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getIsland()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIsland$Response(params: {
    id: Uuid;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<IslandResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IslandsService.GetIslandPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IslandResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getIsland$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIsland(params: {
    id: Uuid;
  },
  context?: HttpContext

): Observable<IslandResponse> {

    return this.getIsland$Response(params,context).pipe(
      map((r: StrictHttpResponse<IslandResponse>) => r.body as IslandResponse)
    );
  }

  /**
   * Path part for operation updateIsland
   */
  static readonly UpdateIslandPath = '/api/islands/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateIsland()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateIsland$Response(params: {
    id: Uuid;
    name?: string;
    catalog?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<IslandResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IslandsService.UpdateIslandPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('name', params.name, {});
      rb.query('catalog', params.catalog, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IslandResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateIsland$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateIsland(params: {
    id: Uuid;
    name?: string;
    catalog?: string;
  },
  context?: HttpContext

): Observable<IslandResponse> {

    return this.updateIsland$Response(params,context).pipe(
      map((r: StrictHttpResponse<IslandResponse>) => r.body as IslandResponse)
    );
  }

  /**
   * Path part for operation deleteIsland
   */
  static readonly DeleteIslandPath = '/api/islands/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteIsland()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteIsland$Response(params: {
    id: Uuid;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, IslandsService.DeleteIslandPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteIsland$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteIsland(params: {
    id: Uuid;
  },
  context?: HttpContext

): Observable<void> {

    return this.deleteIsland$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
